<script lang="ts" setup>
import { ref, computed } from "vue"
import { profile_menu } from "~/common/main_menu"
import type { MenuItem } from "~/models/MenuItem"
import { useFilteredMenu, useLeftMenu } from "~/composables/LefMenu"
import { useDefaultSettingsStore } from "~/stores/defaultSettingsStore"
import type { User } from "~/models/User"
import { useCategoriesStore } from "~/stores/categoriesStore"
import CoinSelect from "./CoinSelect.vue"
import DrawerContainer from "~/layouts/partials/DrawerContainer.vue"
import ListCartShop from "./Cart/ListCartShop.vue"
/**
 *
 *  Props and emits section
 *
 *
 */

const props = defineProps<{
    toggleDrawer: () => void
}>()

/**
 *
 *  Ref, computed and hooks section
 *
 *
 */

const filtered_main_menu = useFilteredMenu()
const user = useSanctumUser<User>()
const can = useCan()
const router = useRouter()
const route = useRoute()
const isMenuOpen = ref(false)
const { $bus } = useNuxtApp()
const expanded = ref<number[]>([])
const drawerShopCart = ref()
const computedToggleDrawer = computed(() => {
   return () => props.toggleDrawer()
})

const computedLastOneReadPermission = computed(() => {
    return (
        (user.value?.all_permissions ?? []).filter((item) =>
            item.includes("read")
        ).length > 0
    )
})

/**
 *
 *  Life cicle events
 *
 *
 */

/**
 *
 *  Functions section
 *
 *
 */
 const handleOpenDrawer = () =>{
    if(props.toggleDrawer){
        computedToggleDrawer.value()
    }
    else{
        toggleMenu()
    }
}


const toggleMenu = () => {
    isMenuOpen.value = !isMenuOpen.value
}

async function profile() {
    router.push("/profile/edit")
}
function logout() {
    router.push("/logout")
}

function goTo(route_name: string) {
    router.push(route_name)
}
function canShow(item: MenuItem) {
    //return can(item?.can ?? null, user.value)
    return can()
}

const closeMenu = () => {
    if (isMenuOpen.value) {
        toggleMenu()
    }
}
const openCart = () => {
    drawerShopCart.value.toggleDrawer()
}

const lowerCase = (value: string) => `${value}`.toLowerCase()
</script>
<template>
    <div class="tw-w-full tw-relative" id="nav">
        <nav
            v-if="
                (user &&
                    (lowerCase(ROLES.ADMIN).includes(
                        lowerCase(user?.role?.name)
                    ) ||
                        lowerCase(ROLES.SUPER).includes(
                            lowerCase(user?.role?.name)
                        ) ||
                        lowerCase(ROLES.ADMON).includes(
                            lowerCase(user?.role?.name)
                        ))) ||
                computedLastOneReadPermission
            "
            class="tw-py-1 tw-bg-black"
            aria-label="Navigation"
        >
            <div
                class="max-container tw-flex tw-justify-between tw-gap-2 tw-text-white tw-text-sm tw-relative admin-top-menu"
            >
                <div class="tw-flex tw-gap-2">
                    <AdminTopMenu :menu="filtered_main_menu"></AdminTopMenu>
                </div>
            </div>
        </nav>
        <slot name="pre-nav"></slot>
        <nav
            class="tw-w-full tw-min-h-[113px] tw-py-4 tw-bg-white tw-border-b tw-border-b-gray-200"
            aria-label="Navigation"
        >
            <div
                class="max-container tw-flex tw-justify-between tw-items-center tw-relative"
            >
                <!-- Mobile Menu Button -->
                <button
                    class="lg:tw-hidden tw-text-primary hover:tw-text-secondary focus:tw-outline-none tw-cursor-pointer"
                    @click="handleOpenDrawer"
                    style="background: none"
                >
                    <q-icon name="menu" size="36px"></q-icon>
                </button>

                <NuxtLink to="/" class="lg:tw-hidden">
                    <ApplicationLogo class="lg:tw-w-[204px] lg:tw-h-[80px]" />
                </NuxtLink>

                <div
                    class="tw-flex tw-gap-4 tw-justify-evenly tw-items-center lg:tw-hidden"
                >
                    <CoinSelect/>
                    <ProfileMenu class="!tw-flex !tw-flex-col" />
                    <ShopCartButton @openCart="openCart" />
                </div>

                <!-- Desktop Menu (768px and larger) -->
                <div
                    v-if="!isMenuOpen"
                    class="tw-hidden lg:tw-flex tw-h-full tw-w-full"
                >
                    <HomeMenu >
                        <template #shopCartButton>
                            <ShopCartButton @openCart="openCart" />
                        </template>
                    </HomeMenu>
                </div>
            </div>
        </nav>

    <CartDrawerInfo ref="drawerShopCart">
            <ListCartShop />
    </CartDrawerInfo>

    </div>
</template>
<style scoped>
.carrito-container {
    position: relative;
    display: inline-block;
}

.carrito-cantidad {
    position: absolute;
    top: -10px;
    right: -10px;
    background-color: #0674bf;
    color: white;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    padding: 0px 4px;
    text-align: center;
    font-size: 12px;

    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
